<template>
  <div class="comments">
    <h2 class="mb-3">Комментарии</h2>
    <Comment
      v-for="comment in comments"
      :key="comment.id"
      :id-comment="comment.id"
      :created-at="comment.created_at"
      :user-id="comment.creator_user_id"
      :text="comment.comment"
      :parent_comment="comment.parent_comment"
      :files="comment.files"
      class="comment"
      @editComment="editComment(comment)"
      @replyComment="replyComment(comment)"
      @remove="removeComment"
      @scrollToRepliedComment="scrollToRepliedComment"
    />
    <CommentSubmitForm
      class="submit-form"
      no-focus
      :needFileUploadButton="true"
      :loading="savingComment"
      :id-comment="idComment"
      :is-reply="isReply"
      :text="text"
      :old-value="oldValue"
      :is-need-to-refresh="isNeedToRefresh"
      @addFiles="addFiles"
      @submit="submitComment"
      @cancelReplyOrEdit="cancelReplyOrEdit"
      @setReplyComment="setReplyComment"
      @setEditComment="setEditComment"
      @refreshed="refreshed"
    />
  </div>
</template>

<script>
import Comment from "@components/comments/Comment.vue";
import CommentSubmitForm from "@components/comments/CommentSubmitForm";
import { mixinComments } from "@/mixins/mixinComments";

export default {
  mixins: [mixinComments],

  props: {
    taskId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      comments: [],
      files: [],
      savingComment: false,
      apiName: 'task',
      idName: 'task_id',
    };
  },

  components: {
    Comment,
    CommentSubmitForm,
  },

  computed: {
    currentId() {
      return this.taskId;
    }
  },

  methods: {
    async fetchComments() {
      this.comments = await this.$api.task.getComments(this.taskId);
    },

    removeComment(id) {
      this.editCommentStatus = true;
      this.$api.task.removeComment(id).then(() => {
        this.fetchComments();
      });
    },
  },

  async mounted() {
    this.fetchComments();
  },
};
</script>

<style lang="scss" scoped>
.comment {
  margin-bottom: 10px;
  background: #f3f3f3;
}
</style>
